// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sitemapContainer .sitemap {
  padding-bottom: 4%;
}
.sitemapContainer .sitemap .sitemapSection .heading {
  margin-bottom: 16px;
}
.sitemapContainer .sitemap .sitemapSection .sitemapList {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sitemapContainer .sitemap .sitemapSection .sitemapList .sitemapItem {
  margin-bottom: 10px;
}
.sitemapContainer .sitemap .sitemapSection .sitemapList .sitemapItem a {
  color: #333;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s ease;
}
.sitemapContainer .sitemap .sitemapSection .sitemapList .sitemapItem a:hover {
  color: #3fb9ea;
}`, "",{"version":3,"sources":["webpack://./src/Defaults/Footer/Sitemap/Style.scss"],"names":[],"mappings":"AAOE;EACE,kBAAA;AANJ;AASM;EACE,mBAAA;AAPR;AAUM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAUU;EACE,WAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;AARZ;AAUY;EACE,cA7BJ;AAqBV","sourcesContent":["// Color Variables\n$primary: #3fb9ea;\n$secondary: #d60000;\n$hover: #b80000;\n$gray: #808080;\n\n.sitemapContainer {\n  .sitemap {\n    padding-bottom: 4%;\n\n    .sitemapSection {\n      .heading {\n        margin-bottom: 16px;\n      }\n\n      .sitemapList {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n\n        .sitemapItem {\n          margin-bottom: 10px;\n\n          a {\n            color: #333;\n            text-decoration: none;\n            font-size: 1rem;\n            transition: color 0.2s ease;\n\n            &:hover {\n              color: $primary;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
